import { TicketTypes } from '@tickets/constants';
import { BetStateViewEnum } from '@app/dev/constants/enums/betState';
import { BetHistoryEnumMap, betTypes } from '../constants/betHistoryConstants';

export const mapBetHistoryTicket = (scoresInfo) => (
  (ticket) => ({
    ticketType: TicketTypes.SPORT,
    dataFromSwarm: {
      ...ticket,
      created: ticket.date_time * 1000,
      price: ticket.k,
      state_id: BetHistoryEnumMap[ticket.outcome],
      state_name: BetStateViewEnum[BetHistoryEnumMap[ticket.outcome]],
      win_amount: ticket.payout,
      type_name: betTypes[ticket.type],
      cashout_amount: ticket.cash_out,
      selection_list: ticket.events.map((event) => ({
        ...event,
        match_id: event.match_display_id,
        match_name: event.game_name,
        match_info: scoresInfo[event.match_display_id],
        display_market_name: event.market_name,
        display_selection_name: event.event_name,
        selection_name: event.event_name,
        price: event.coeficient,
        state: BetHistoryEnumMap[event.outcome],
        state_id: BetHistoryEnumMap[event.outcome],
        state_name: BetStateViewEnum[BetHistoryEnumMap[event.outcome]],
      })),
    },
  })
);
